const About = {
  SystemInfo: "About.SystemInfo",
  LicenseAttributions: "About.LicenseAttributions",
  LicenseSubText1: "About.LicenseSubText1",
  LicenseSubText2: "About.LicenseSubText2",
  GithubRepo: "About.GithubRepo",
  License: "About.License",
  NotModifiedInfoText: "About.NotModifiedInfoText",
  }
export default About;